import { render, staticRenderFns } from "./IncOrderStatus.vue?vue&type=template&id=ec369c8c"
import script from "./IncOrderStatus.vue?vue&type=script&lang=js"
export * from "./IncOrderStatus.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports